export const REPAYMENT_AMOUNT = [ 
  {
    amount: 350,
    repayment: [35, 40, 45],
  },
  {
    amount: 450,
    repayment: [45, 50, 55],
  },
  {
    amount: 700,
    repayment: [40, 45, 50],
  },
  {
    amount: 1000,
    repayment: [50, 55, 60],
  },
  {
    amount: 1500,
    repayment: [55, 60, 65],
  },
  {
    amount: 2250,
    repayment: [60, 70, 80],
  },
  {
    amount: 2500,
    repayment: [70, 80, 85],
  },
  {
    amount: 2750,
    repayment: [75, 80, 85],
  },
  {
    amount: 3000,
    repayment: [80, 85, 90],
  },
  {
    amount: 4000,
    repayment: [80, 90, 100],
  },
  {
    amount: 5950,
    repayment: [90, 100, 110],
  },
  {
    amount: 6450,
    repayment: [95, 100, 110],
  },
  {
    amount: 6950,
    repayment: [105, 110, 115],
  },
  {
    amount: 7450,
    repayment: [112, 120, 125],
  },
  {
    amount: 7950,
    repayment: [95, 105, 110],
  },
  {
    amount: 8450,
    repayment: [100, 105, 110],
  },
  {
    amount: 8950,
    repayment: [105, 110, 115],
  },
  {
    amount: 9500,
    repayment: [110, 115, 120],
  },
  {
    amount: 9950,
    repayment: [115, 120, 125],
  },
  {
    amount: 10000,
    repayment: [122, 130, 135],
  },
];
